import { render, staticRenderFns } from "./P06WinDigit.vue?vue&type=template&id=c4cf1e8a&scoped=true"
import script from "./P06WinDigit.vue?vue&type=script&lang=js"
export * from "./P06WinDigit.vue?vue&type=script&lang=js"
import style0 from "./P06WinDigit.vue?vue&type=style&index=0&id=c4cf1e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cf1e8a",
  null
  
)

export default component.exports